export const BOOTSTRAP = 'bootstrap/INIT_BOOTSTRAP';
export const BOOTSTRAP_SUCCESS = 'bootstrap/BOOTSTRAP_SUCCESS';
export const BOOTSTRAP_ERROR = 'bootstrap/BOOTSTRAP_ERROR';
export const BOOTSTRAP_COMPLETE = 'bootstrap/BOOTSTRAP_COMPLETE';

export const FIREBASE_INIT = 'bootstrap/FIREBASE_INIT';
export const FIREBASE_INIT_SUCCESS = 'bootstrap/FIREBASE_INIT_SUCCESS';
export const FIREBASE_INIT_ERROR = 'bootstrap/FIREBASE_INIT_ERROR';